import { render, staticRenderFns } from "./ImageButtonView.vue?vue&type=template&id=d0c3880a&"
import script from "./ImageButtonView.vue?vue&type=script&lang=js&"
export * from "./ImageButtonView.vue?vue&type=script&lang=js&"
import style0 from "./ImageButtonView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports